import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { Borrower } from '@/types'

type ReadBorrowerParams = {
  companyKey: string
  params?: { borrower_key?: string; tax_id?: string }
}

export const readBorrower = async ({
  companyKey,
  params,
}: ReadBorrowerParams) => {
  const response = await httpClient('accounting-dealer').get<Borrower>(
    `/v3/company/${companyKey}/borrower`,
    { params },
  )
  return response.data
}

export const useReadBorrower = (
  params: ReadBorrowerParams,
  options?: Partial<UseQueryOptions<Borrower, Error, Borrower>>,
) => {
  return useQuery({
    queryKey: ['borrower', params],
    queryFn: () => readBorrower(params),
    enabled: !!params.params?.borrower_key || !!params.params?.tax_id,
    ...options,
  })
}
